<template>
  <!-- 不显示头部和底部 -->
  <div id="app" v-if="['HsyDemo','MonitoringVideoPlayback','FlvDemo'].includes($route.name)">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
  <div id="app" v-else>
    <Ceiling></Ceiling>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <Bottom></Bottom>
    <LinkUs></LinkUs>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
import LinkUs from './components/LinkUs'
export default {
  name: 'App',
  components: {
    LinkUs
  },
  mounted(){
    // 监听网络访问量51LA
    !function(p){"use strict";!function(t){var s=window,e=document,i=p,c="".concat("https:"===e.location.protocol?"https://":"http://","sdk.51.la/js-sdk-pro.min.js"),n=e.createElement("script"),r=e.getElementsByTagName("script")[0];n.type="text/javascript",n.setAttribute("charset","UTF-8"),n.async=!0,n.src=c,n.id="LA_COLLECT",i.d=n;var o=function(){s.LA.ids.push(i)};s.LA?s.LA.ids&&o():(s.LA=p,s.LA.ids=[],o()),r.parentNode.insertBefore(n,r)}()}({id:"JrFSluP45Q5Ou5LT",ck:"JrFSluP45Q5Ou5LT"});
  }
}
</script>

<style>
</style>
